@use '../../../styles/variables' as *;
@use '../../../styles/mixins' as *;

.inventory {
  display: flex;
  gap: $space-lg;
  max-width: 700px;
  height: 340px;
  width: 100%;
}

.columnLeft {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: $space-sm;
  overflow-y: auto;
  min-width: 0;

  @include scrollbar;
}

.columnRight {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: $space-sm;
  min-height: 0;
}
